"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATIONS_QUERY_PARAMETER_NAME = exports.TRANSLATIONS_ENDPOINT = exports.TRANSLATIONS_CACHE_MAX_AGE = exports.FILE_HEADER = exports.ENTRIES_DELIMITER = exports.DYNAMIC_TRANSLATION_PREFIX = exports.DEFAULT_LOCALIZATION_FILES_FOLDER_NAME = void 0;
/**
 * The delimiter used to join entries in the generated files.
 */
const ENTRIES_DELIMITER = exports.ENTRIES_DELIMITER = '\n  ';

/**
 * Custom content prepended to all generated files.
 */
const FILE_HEADER = exports.FILE_HEADER = `/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script \`localizations-codegen\`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run \`npx localizations-codegen\` to regenerate.
 */`;
const TRANSLATIONS_CACHE_MAX_AGE = exports.TRANSLATIONS_CACHE_MAX_AGE = 15;
const TRANSLATIONS_ENDPOINT = exports.TRANSLATIONS_ENDPOINT = '/system/ajax/Localization/Translate';
const TRANSLATIONS_QUERY_PARAMETER_NAME = exports.TRANSLATIONS_QUERY_PARAMETER_NAME = 'keys';
const DYNAMIC_TRANSLATION_PREFIX = exports.DYNAMIC_TRANSLATION_PREFIX = '_dynamic_translation_';
const DEFAULT_LOCALIZATION_FILES_FOLDER_NAME = exports.DEFAULT_LOCALIZATION_FILES_FOLDER_NAME = 'resources';
//# sourceMappingURL=index.js.map